// Get cookie value by name
export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return decodeURIComponent(parts.pop().split(';').shift());
  return null;
};

// Set cookie value with subdomain sharing support
export const setCookie = (name, value, days = 7) => {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  const hostname = window.location.hostname;
  const isHttps = window.location.protocol === 'https:';
  
  let cookieString = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/`;

  if (hostname.endsWith('topinteriorsindia.com')) {
    cookieString += '; domain=.topinteriorsindia.com';
  }

  if (isHttps) {
    cookieString += '; Secure; SameSite=Lax';
  }

  document.cookie = cookieString;
};

// Remove cookie
export const removeCookie = (name) => {
  const hostname = window.location.hostname;
  const isHttps = window.location.protocol === 'https:';
  
  let cookieString = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;

  if (hostname.endsWith('topinteriorsindia.com')) {
    cookieString += '; domain=.topinteriorsindia.com';
  }

  if (isHttps) {
    cookieString += '; Secure; SameSite=Lax';
  }

  document.cookie = cookieString;
};

// authStorage wrapper that matches localStorage interface for auth tokens
export const authStorage = {
  getItem: (key) => {
    if (['token', 'refreshToken', 'user'].includes(key)) {
      return getCookie(key);
    }
    return localStorage.getItem(key);
  },
  setItem: (key, value) => {
    if (['token', 'refreshToken', 'user'].includes(key)) {
      const days = key === 'refreshToken' ? 30 : 7;
      setCookie(key, value, days);
      return;
    }
    localStorage.setItem(key, value);
  },
  removeItem: (key) => {
    if (['token', 'refreshToken', 'user'].includes(key)) {
      removeCookie(key);
      return;
    }
    localStorage.removeItem(key);
  }
};

export default authStorage;
